<template>
  <el-container v-loading="loading" element-loading-text="Przypisywanie projektu...">
    <el-main class="main">
      <Logo />
      <p>Aby przypisać swój wcześniej utworzony projekt do zamówienia podaj jego kod poniżej.</p>
      <el-form ref="form" :model="this" :disabled="loading">
        <el-form-item>
          <el-input placeholder="Kod projektu" v-model="hash"></el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="assignAttempt">Przypisz</el-button>
        </el-form-item>
      </el-form>
    </el-main>
  </el-container>
</template>

<script>
  import { mapGetters } from 'vuex'
  import projectService from '../services/project';
  import Logo from '../components/Common/Logo.vue'
  
  export default {
    name: 'Assign',
    data() {
      return {
        hash: '',
        loading: false,
        error: false
      }
    },
    computed: {
      ...mapGetters('creator', [
        'project',
      ]),
    },
    methods: {
      async assignAttempt() {
        this.loading = true

        const result = await projectService.setOrderId(this.hash, this.$route.params.orderId)

        this.loading = false

        if (result) {
            this.$notify({
              title: 'OK!',
              message: 'Projekt został pomyślnie przypisany do zamówienia',
              type: 'success',
              position: 'bottom-right'
            })

          window.location.href = `/editor/${this.hash}`
        } else {
            this.$notify.error({
              title: 'Ups!',
              message: 'Nie znaleziono projektu. Upewnij się, że kod projektu jest poprawny. Jeżeli problem wciąż występuje, prosimy skontaktuj się z nami.',
              position: 'bottom-right'
            });
        }
      }
    },
    components: {
      Logo
    }
  }
</script>

<style lang="less" scoped>
  body {
    font-family: 'Raleway', sans-serif;
  }
  .el-main.main {
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    text-align: center;
    p {
      max-width: 500px;
      margin: 15px auto 30px;
      color: rgb(146, 146, 146);
    }
  }
</style>